(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let items = [], frame = 0, previous = 0;
  const clamp = value => Math.max(0, Math.min(1, value));
  function progress(item) {
    const r = item.frame.getBoundingClientRect();
    return clamp((innerHeight - r.top) / (innerHeight + r.height));
  }
  function draw(time) {
    const dt = Math.min((time - previous) / 1000 || 1 / 60, .05);
    previous = time;
    let moving = false;
    for (const item of items) {
      const target = progress(item);
      item.current += (target - item.current) * (1 - Math.exp(-dt * 50));
      if (Math.abs(target - item.current) > .0001) moving = true;
      else item.current = target;
      const scale = 1 + .2 * (1 - item.current) ** 2;
      item.image.style.transform = motion.matches ? '' : 'scale(' + (item.logo ? scale / 1.2 : scale) + ')';
    }
    frame = moving ? requestAnimationFrame(draw) : 0;
  }
  function schedule() {
    if (!frame) { previous = performance.now(); frame = requestAnimationFrame(draw); }
  }
  function init() {
    items.forEach(item => item.image.style.transform = '');
    items = [];
    document.querySelectorAll('[id$="__section_aCeFPR"] .image-block, [id$="__section_azWYN4"] .image-block').forEach(el => {
      const image = el.querySelector('img');
      if (image) { el.classList.add('flow-scroll-frame'); items.push({frame:el,image,logo:false,current:0}); }
    });
    document.querySelectorAll('[id$="__section_footer_logo"] .logo-block').forEach(el => {
      const image = el.querySelector('img');
      if (image) items.push({frame:el,image,logo:true,current:0});
    });
    items.forEach(item => item.current = progress(item));
    schedule();
  }
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', init);
  motion.addEventListener('change', schedule);
  new ResizeObserver(schedule).observe(document.body);
  init();
})();